<template>
  <div>
    <b-row>
      <b-col
        md="8"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <p class="h5 mt-50 mr-75 ml-50">
          일별/누적
        </p>
        <b-form-radio-group
          v-model="query.isPrefixSum"
          @change="changePrefixSum"
        >
          <b-form-radio :value="false">
            일별 (기간:최대30일)
          </b-form-radio>
          <b-form-radio :value="true">
            누적 (기간:최대1년)
          </b-form-radio>
        </b-form-radio-group>
        <b-form-datepicker
          v-model="query.startDate"
          class="el-def"
          placeholder="조회기간(Fr)"
          style="width: 240px"
        />
        <label class="ml-50 mr-50">~</label>
        <b-form-datepicker
          v-model="query.endDate"
          class="el-def"
          placeholder="조회기간(To)"
          style="width: 240px"
        />
        <label class="ml-50">(*당일데이터 조회 불가)</label>
      </b-col>
      <b-col
        md="4"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="fetchData()"
        >
          조회
        </b-button>
        <b-button
          variant="outline-dark"
          class="btn-search ml-1"
          @click.prevent="excelDownload()"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-50"
          />
          <span>엑셀 다운로드</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-table-simple
          bordered
          responsive
          sticky-header
          style="max-height: 65vh;"
        >
          <colgroup>
            <col style="width: 140px">
            <!-- 자동실행 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 도구모음+도움말+라이브뉴스 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 팝업 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 전체 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
          </colgroup>
          <b-thead head-variant="light">
            <b-tr>
              <b-th
                rowspan="3"
                class="sticky-header"
                style="left: 0"
              >
                구분
              </b-th>
              <b-th colspan="6">
                자동실행
              </b-th>
              <b-th colspan="6">
                도구모음+도움말+라이브뉴스
              </b-th>
              <b-th colspan="6">
                팝업
              </b-th>
              <b-th colspan="6">
                전체
              </b-th>
            </b-tr>
            <b-tr>
              <b-th colspan="3">
                유입 수
              </b-th>
              <b-th colspan="3">
                유입자 수
              </b-th>
              <b-th colspan="3">
                유입 수
              </b-th>
              <b-th colspan="3">
                유입자 수
              </b-th>
              <b-th colspan="3">
                유입 수
              </b-th>
              <b-th colspan="3">
                유입자 수
              </b-th>
              <b-th colspan="3">
                유입 수
              </b-th>
              <b-th colspan="3">
                유입자 수
              </b-th>
            </b-tr>
            <b-tr>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
              <b-th>회원</b-th>
              <b-th>비회원</b-th>
              <b-th>전체</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="data.length > 0">
            <b-tr
              v-for="(m, idx) in data"
              :key="`tr-${idx}`"
            >
              <b-td>{{ m.isPrefixSum ? '누적 수' : m.date }}</b-td>

              <!-- 자동실행 = (신) 자동실행 -->
              <b-td>{{ m.autoEntryTotalMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ m.autoEntryTotalNonMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ (m.autoEntryTotalMemberCountNew + m.autoEntryTotalNonMemberCountNew) | $numberFormatter }}</b-td>
              <b-td>{{ m.autoEntryGroupMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ m.autoEntryGroupNonMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ (m.autoEntryGroupMemberCountNew + m.autoEntryGroupNonMemberCountNew) | $numberFormatter }}</b-td>

              <!-- 도구모음+도움말+라이브뉴스 = (신) 진료실 호출 -->
              <b-td>{{ m.iconEntryTotalMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ m.iconEntryTotalNonMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ (m.iconEntryTotalMemberCountNew + m.iconEntryTotalNonMemberCountNew) | $numberFormatter }}</b-td>
              <b-td>{{ m.iconEntryGroupMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ m.iconEntryGroupNonMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ (m.iconEntryGroupMemberCountNew + m.iconEntryGroupNonMemberCountNew) | $numberFormatter }}</b-td>

              <!-- 팝업 = (신) 팝업 -->
              <b-td>{{ m.popupEntryTotalMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ m.popupEntryTotalNonMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ (m.popupEntryTotalMemberCountNew + m.popupEntryTotalNonMemberCountNew) | $numberFormatter }}</b-td>
              <b-td>{{ m.popupEntryGroupMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ m.popupEntryGroupNonMemberCountNew | $numberFormatter }}</b-td>
              <b-td>{{ (m.popupEntryGroupMemberCountNew + m.popupEntryGroupNonMemberCountNew) | $numberFormatter }}</b-td>

              <!-- 전체 = 전체 합산 중 83(모아보기_닥터인포바로가기_클릭) 제거-->
              <b-td>{{ m.allEntryTotalMemberCount | $numberFormatter }}</b-td>
              <b-td>{{ m.allEntryTotalNonMemberCount | $numberFormatter }}</b-td>
              <b-td>{{ (m.allEntryTotalMemberCount + m.allEntryTotalNonMemberCount) | $numberFormatter }}</b-td>
              <b-td>{{ m.allEntryGroupMemberCount | $numberFormatter }}</b-td>
              <b-td>{{ m.allEntryGroupNonMemberCount | $numberFormatter }}</b-td>
              <b-td>{{ (m.allEntryGroupMemberCount + m.allEntryGroupNonMemberCount) | $numberFormatter }}</b-td>

            </b-tr>
          </b-tbody>

          <b-tbody v-else>
            <b-tr>
              <b-td colspan="3">
                <div
                  role="alert"
                  aria-live="polite"
                >
                  <div class="text-center my-2">
                    일치하는 데이터가 없습니다.
                  </div>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from '@axios'
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  setup() {
    const data = ref([])

    onMounted(() => {
      fetchData()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const changePrefixSum = () => {
      if (query.value.isPrefixSum) {
        query.value.startDate = dayjs().add(-1, 'month').format('YYYY-MM-DD')
      } else {
        query.value.startDate = dayjs().add(-7, 'day').format('YYYY-MM-DD')
      }

      query.value.endDate = dayjs().add(-1, 'day').format('YYYY-MM-DD')
    }

    const query = ref({
      startDate: dayjs().add(-7, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
      isPrefixSum: false,
    })

    const fetchData = () => {
      const frDate = dayjs(query.value.startDate)
      const toDate = dayjs(query.value.endDate)

      if (query.value.isPrefixSum && Math.abs(frDate.diff(toDate, 'day')) > 365) {
        pushToast('warning', '조회 기간은 최대 1년을 넘을 수 없습니다.')
        return
      }
      if (query.value.isPrefixSum === false && Math.abs(frDate.diff(toDate, 'day')) > 30) {
        pushToast('warning', '조회 기간은 최대 30일을 넘을 수 없습니다.')
        return
      }

      axios.get('/fa/stats-entry/route', {
        params: {
          startDate: query.value.startDate,
          endDate: query.value.endDate,
          isPrefixSum: query.value.isPrefixSum,
        },
      })
        .then(rs => {
          data.value = rs.data
          console.log('data', data.value)
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    const excelDownload = async () => {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet("sheet1")

      worksheet.addRow()

      worksheet.getCell('A1').value = '구분'
      worksheet.mergeCells(`A1:A3`)
      worksheet.getCell('B1').value = '자동실행'
      worksheet.mergeCells(`B1:G1`)
      worksheet.getCell('H1').value = '도구모음+도움말+라이브뉴스'
      worksheet.mergeCells(`H1:M1`)
      worksheet.getCell('N1').value = '팝업'
      worksheet.mergeCells(`N1:S1`)
      worksheet.getCell('T1').value = '전체'
      worksheet.mergeCells(`T1:Y1`)

      worksheet.getCell('B2').value = '유입 수'
      worksheet.mergeCells(`B2:D2`)
      worksheet.getCell('E2').value = '유입자 수'
      worksheet.mergeCells(`E2:G2`)
      worksheet.getCell('H2').value = '유입 수'
      worksheet.mergeCells(`H2:J2`)
      worksheet.getCell('K2').value = '유입자 수'
      worksheet.mergeCells(`K2:M2`)
      worksheet.getCell('N2').value = '유입 수'
      worksheet.mergeCells(`N2:P2`)
      worksheet.getCell('Q2').value = '유입자 수'
      worksheet.mergeCells(`Q2:S2`)
      worksheet.getCell('T2').value = '유입 수'
      worksheet.mergeCells(`T2:V2`)
      worksheet.getCell('W2').value = '유입자 수'
      worksheet.mergeCells(`W2:Y2`)

      worksheet.getCell('B3').value = '회원'
      worksheet.getCell('C3').value = '비회원'
      worksheet.getCell('D3').value = '전체'
      worksheet.getCell('E3').value = '회원'
      worksheet.getCell('F3').value = '비회원'
      worksheet.getCell('G3').value = '전체'
      worksheet.getCell('H3').value = '회원'
      worksheet.getCell('I3').value = '비회원'
      worksheet.getCell('J3').value = '전체'
      worksheet.getCell('K3').value = '회원'
      worksheet.getCell('L3').value = '비회원'
      worksheet.getCell('M3').value = '전체'
      worksheet.getCell('N3').value = '회원'
      worksheet.getCell('O3').value = '비회원'
      worksheet.getCell('P3').value = '전체'
      worksheet.getCell('Q3').value = '회원'
      worksheet.getCell('R3').value = '비회원'
      worksheet.getCell('S3').value = '전체'
      worksheet.getCell('T3').value = '회원'
      worksheet.getCell('U3').value = '비회원'
      worksheet.getCell('V3').value = '전체'
      worksheet.getCell('W3').value = '회원'
      worksheet.getCell('X3').value = '비회원'
      worksheet.getCell('Y3').value = '전체'

      const columns = [
        { key: "date", width: 20 },

        /* 자동실행 */
        { key: "autoEntryTotalMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "autoEntryTotalNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "autoEntryTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "autoEntryGroupMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "autoEntryGroupNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "autoEntryGroupCount", width: 15, style: { numFmt: '#,##0' } },

        /* 도구모음+도움말+라이브뉴스 */
        { key: "iconEntryTotalMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "iconEntryTotalNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "iconEntryTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "iconEntryGroupMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "iconEntryGroupNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "iconEntryGroupCount", width: 15, style: { numFmt: '#,##0' } },

        /* 팝업 */
        { key: "popupEntryTotalMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "popupEntryTotalNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "popupEntryTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "popupEntryGroupMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "popupEntryGroupNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "popupEntryGroupCount", width: 15, style: { numFmt: '#,##0' } },

        /* 전체 */
        { key: "allEntryTotalMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "allEntryTotalNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "allEntryTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "allEntryGroupMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "allEntryGroupNonMemberCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "allEntryGroupCount", width: 15, style: { numFmt: '#,##0' } },

      ]

      worksheet.columns = columns

      // eslint-disable-next-line array-callback-return
      data.value.map(e => {
        const record = {
          date: e.isPrefixSum ? '누적 수' : e.date,

          /* 자동실행 = (신) 자동실행 */
          autoEntryTotalMemberCount: e.autoEntryTotalMemberCountNew,
          autoEntryTotalNonMemberCount: e.autoEntryTotalNonMemberCountNew,
          autoEntryTotalCount: (e.autoEntryTotalMemberCountNew + e.autoEntryTotalNonMemberCountNew),
          autoEntryGroupMemberCount: e.autoEntryGroupMemberCountNew,
          autoEntryGroupNonMemberCount: e.autoEntryGroupNonMemberCountNew,
          autoEntryGroupCount: (e.autoEntryGroupMemberCountNew + e.autoEntryGroupNonMemberCountNew),

          /* 도구모음+도움말+라이브뉴스 = (신) 진료실 호출 */
          iconEntryTotalMemberCount: e.iconEntryTotalMemberCountNew,
          iconEntryTotalNonMemberCount: e.iconEntryTotalNonMemberCountNew,
          iconEntryTotalCount: (e.iconEntryTotalMemberCountNew + e.iconEntryTotalNonMemberCountNew),
          iconEntryGroupMemberCount: e.iconEntryGroupMemberCountNew,
          iconEntryGroupNonMemberCount: e.iconEntryGroupNonMemberCountNew,
          iconEntryGroupCount: (e.iconEntryGroupMemberCountNew + e.iconEntryGroupNonMemberCountNew),

          /* 팝업 = (신) 팝업 */
          popupEntryTotalMemberCount: e.popupEntryTotalMemberCountNew,
          popupEntryTotalNonMemberCount: e.popupEntryTotalNonMemberCountNew,
          popupEntryTotalCount: (e.popupEntryTotalMemberCountNew + e.popupEntryTotalNonMemberCountNew),
          popupEntryGroupMemberCount: e.popupEntryGroupMemberCountNew,
          popupEntryGroupNonMemberCount: e.popupEntryGroupNonMemberCountNew,
          popupEntryGroupCount: (e.popupEntryGroupMemberCountNew + e.popupEntryGroupNonMemberCountNew),

          /* 전체 = 전체 합산 중 83(모아보기_닥터인포바로가기_클릭) 제거 */
          allEntryTotalMemberCount: e.allEntryTotalMemberCount,
          allEntryTotalNonMemberCount: e.allEntryTotalNonMemberCount,
          allEntryTotalCount: e.allEntryTotalMemberCount + e.allEntryTotalNonMemberCount,
          allEntryGroupMemberCount: e.allEntryGroupMemberCount,
          allEntryGroupNonMemberCount: e.allEntryGroupNonMemberCount,
          allEntryGroupCount: e.allEntryGroupMemberCount + e.allEntryGroupNonMemberCount,

        }

        worksheet.addRow(record)
      })

      worksheet.eachRow({ includeEmpty: true }, (row, number) => {
        row.eachCell({ includeEmpty: true }, cell => {
          if (number === 1 || number === 2 || number === 3) {
            // eslint-disable-next-line no-param-reassign
            cell.font = {
              bold: true,
            }

            // eslint-disable-next-line no-param-reassign
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            }
          }

          // eslint-disable-next-line no-param-reassign
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }

          if (cell.value === '소계' || cell.value === '합계') {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          }
        })
      })

      const mimeType = {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], mimeType)

      saveAs(blob, "진입경로별_유입현황.xlsx")
    }

    return {
      data,
      query,
      fetchData,
      changePrefixSum,
      excelDownload,
    }
  },
}
</script>

<style scoped>
.table-bordered th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}
</style>
